import type { SopModuleType } from "@/redux/sopModule/sopTypes";

export const initialState: SopModuleType = {
  success: null,
  error: null,
  statusCode: null,
  message: "",
  fetching: false,
  uniqueCheckFileNameMessage: "",
  uniqueCheckFileNameFetching: false,
  sopModuleList: [],
  sopModuleTotalCount: 0,
  singleSopDetails: {},
};
